import React, { useCallback, useContext, useState } from 'react';

import { t } from 'i18next';
import { Trans } from 'react-i18next';

import { ReactComponent as HappyBuddy } from '../../../../../../assets/icons/buddy-happy-open-eyes.svg';
import BdsModal from '../../../../../../shared/components/v3/Modals/BdsModal/BdsModal';
import Toast from '../../../../../../shared/components/v3/Toast/Toast';
import {
  DELETE_COLLABORATOR_ERROR_TOAST,
  DELETE_COLLABORATOR_SUCCESS_TOAST_NE
} from '../../../../../../shared/constants/toast';
import { CompanyContext } from '../../../../../../shared/context/company/companyContext';
import { ICollaboratorsModal } from '../../../../../../shared/interfaces/collaboratosModal';
import { IToast } from '../../../../../../shared/interfaces/toast';
import Holding from '../../../../../../shared/services/api/holdings/holdings';
import { TRANSLATION_COLLABORATORS } from '../../../../../../shared/translations/collaborators';

const CollaboratorsDismissModal = ({ openModal, setOpenModal, emails, onFinally }: ICollaboratorsModal) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [openToast, setOpenToast] = useState<boolean>(false);
  const [toastData, setToastData] = useState<IToast>();
  const { holding } = useContext(CompanyContext);

  const handleCloseToast = useCallback(() => {
    setOpenToast(false);
  }, []);

  const deleteCollabs = async () => {
    setLoading(true);
    try {
      await Holding.dismissPendingMembers(holding.id, emails);

      await onFinally(emails);

      setToastData(DELETE_COLLABORATOR_SUCCESS_TOAST_NE);
    } catch {
      setToastData(DELETE_COLLABORATOR_ERROR_TOAST);
    } finally {
      setOpenToast(true);
      setLoading(false);
      handleOnCloseModal();
    }
  };

  const handleOnCloseModal = useCallback(() => {
    if (!loading) {
      setOpenModal(false);
    }
  }, [loading, setOpenModal]);

  return (
    <>
      <BdsModal
        open={openModal}
        icon={<HappyBuddy />}
        title={t(TRANSLATION_COLLABORATORS.modal.deleteCollaborators.title, { count: emails.length })}
        loading={loading}
        description={
          <Trans
            i18nKey={TRANSLATION_COLLABORATORS.modal.deleteCollaborators.description}
            values={{ user_email: emails.map((email) => email), count: emails.length }}
            components={{
              b: <b></b>
            }}
          />
        }
        onClose={handleOnCloseModal}
        primaryAction={{
          label: t(TRANSLATION_COLLABORATORS.modal.deleteCollaborators.confirmButton),
          onClick: deleteCollabs
        }}
        secondaryAction={{
          label: t(TRANSLATION_COLLABORATORS.modal.deleteCollaborators.cancelButton),
          onClick: handleOnCloseModal
        }}
      />
      <Toast
        title={t(toastData?.title || '', { count: emails.length })}
        description={t(toastData?.description || '', { count: emails.length })}
        open={openToast}
        button={toastData?.button}
        buttonAction={handleCloseToast}
        handleClose={handleCloseToast}
        icon={toastData?.icon}
      />
    </>
  );
};
export default CollaboratorsDismissModal;
